import React from 'react';
import { TariffKindInternal } from '../../../../../../data-access/gql-types/graphql';
import { useTariffConfigurationContext } from '../../context/tariff-configuration-context';
import { ChartDynamic } from '../../../common/tariff/charts-presentation/chart-dynamic';
import { ChartG11 } from '../../../common/tariff/charts-presentation/chart-g11';
import { ChartG13s } from '../../../common/tariff/charts-presentation/chart-g13s';
import { ChartTariff } from '../../../common/tariff/charts-presentation/chart-tariff';

export const TariffPresentation: React.FC = () => {
  const { selectedTariff, formValues } = useTariffConfigurationContext();

  const renderCurrentPrentation = () => {
    if (!selectedTariff) return null;

    if (selectedTariff.includes('_DYNAMIC')) return <ChartDynamic />;
    if (selectedTariff === TariffKindInternal.TauronG13S) return <ChartG13s />;
    if (selectedTariff.includes('11')) return <ChartG11 />;
    if (selectedTariff.length) return <ChartTariff {...formValues} />;

    return null;
  };

  return <div>{renderCurrentPrentation()}</div>;
};
